import { z } from 'zod';

export enum DigitalCreativesSearchKey {
  SEARCH = 'search',
}

export const digitalCreativesRouterSearchParamsSchema = z.object({
  [DigitalCreativesSearchKey.SEARCH]: z.string().optional(),
});
